import React, { useMemo } from 'react';
import { ICalendarInfo, IDatePickerValue, PickerType } from '../../interface';
import { getCalendarHeardLabel, getDaysListByMonth, weekList, onTransformWeekList } from '../../utils/picker';
import dayjs from 'dayjs';
import './index.scss';
import { classSet } from '@umu/umu-dom';
import { IDateInfo } from '../../interface/datePicker';
import _chunk from 'lodash/chunk';
interface IProps {
  value: IDatePickerValue;
  initCalendarInfo?: ICalendarInfo;
  disabledDate?: (date: string) => boolean;
  onChange?: (data: IDatePickerValue) => void;
}
const defaultCalendarInfo: ICalendarInfo = {
  mode: PickerType.date,
  value: dayjs().format('YYYY-MM-DD'),
}

const CalendarDays = (props: IProps) => {
  const { value = [], initCalendarInfo = defaultCalendarInfo, disabledDate, onChange } = props;
  const [calendarInfo, setCalendarInfo] = React.useState<ICalendarInfo>(initCalendarInfo)
  const onPrev = () => {
    const newCalendarInfo = {
      ...calendarInfo,
      value: dayjs(calendarInfo.value).subtract(1, 'year').format('YYYY-MM-DD'),
    }
    setCalendarInfo(newCalendarInfo);
  }
  const onSmallPrev = () => {
    const newCalendarInfo = {
      ...calendarInfo,
      value: dayjs(calendarInfo.value).subtract(1, 'month').format('YYYY-MM-DD'),
    }
    setCalendarInfo(newCalendarInfo);
  }
  const onNext = () => {
    const newCalendarInfo = {
      ...calendarInfo,
      value: dayjs(calendarInfo.value).add(1, 'year').format('YYYY-MM-DD'),
    }
    setCalendarInfo(newCalendarInfo);
  }
  const onSmallNext = () => {
    const newCalendarInfo = {
      ...calendarInfo,
      value: dayjs(calendarInfo.value).add(1, 'month').format('YYYY-MM-DD'),
    }
    setCalendarInfo(newCalendarInfo);
  }
  const WeekList = useMemo(() => {
    return onTransformWeekList(weekList).map((item, index) => <th className='other-days' key={`week-${index}`}>{item}</th>)
  }, [])
  const onDayClick = (info: IDateInfo) => {
    if (disabledDate && disabledDate(info.value)) {
      return;
    }
    if (info.isNonCurrentMonth) {
      const newCalendarInfo = {
        ...calendarInfo,
        value: info.value,
      }
      setCalendarInfo(newCalendarInfo);
      return;
    }
    const list = value as string[];
    if (list.includes(info.value)) {
      const newValue = list.filter((item) => item !== info.value);
      onChange && onChange(newValue);
    } else {
      const newValue = [...list, info.value];
      onChange && onChange(newValue);
    }

  }
  const onIsSelect = (info: IDateInfo) => {
    return value.includes(info.value) && !(disabledDate ? disabledDate(info.value) : false) && !info.isNonCurrentMonth;
  }
  const onIsSelectAndDisabled = (info: IDateInfo) => {
    return value.includes(info.value) && ((disabledDate ? disabledDate(info.value) : false) || info.isNonCurrentMonth);
  }
  const DayList = useMemo(() => {
    const daysList = _chunk(getDaysListByMonth(calendarInfo), 7);
    return daysList.map((one, index) => {
      return <tr key={`days-list-rows-${index}`}>
        {
          one.map((days, col) => {
            return <td
              key={`days-list-rows-${index}-${col}`}
              onClick={() => onDayClick(days)}
              className={classSet({
                'month-day-split': true,
                [days.className]: true,
                'current-date-disabled': disabledDate ? disabledDate(days.value) : false,
                'selected-day': onIsSelect(days),
                'selected-day-disabled': onIsSelectAndDisabled(days),
              })}>
              <div className="month-day-cell-inner">{days.label}</div>
            </td>
          })
        }
      </tr>
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [calendarInfo, value])
  return (
    <div className='umu-design-calendar-info'>
      <div className='calendar-title'>
        <button type="button" className="calendar-header-prev-btn" onClick={onPrev}><span className="calendar-super-prev-icon"></span></button>
        <button type="button" className="calendar-header-prev-btn" onClick={onSmallPrev}><span className="calendar-prev-icon"></span></button>
        <span className='year-number'>{getCalendarHeardLabel(calendarInfo)}</span>
        <button type="button" className="calendar-header-next-btn" onClick={onSmallNext}><span className="calendar-next-icon"></span></button>
        <button type="button" className="calendar-header-super-next-btn" onClick={onNext}><span className="calendar-super-next-icon"></span></button>
      </div>
      <table className='calendar-days-content'>
        <thead><tr>{WeekList}</tr></thead>
        <tbody>{DayList}</tbody>
      </table>
    </div>
  );
}

export {
  CalendarDays
};
